import React from 'react'

import { connect } from 'react-redux'

import BottomCard from './BottomCard'

class BottomBar extends React.PureComponent {

  renderCards() {
    const allIds = Object.keys(this.props.eventIds)
    return allIds.map((eventId, index) => {
      return (
        <BottomCard
          key={index}
          eventInfo={this.props.eventInfos[eventId]}
          eventId={eventId}
          dateStr={this.props.dateStr} />
      )
    })
  }

  render() {
    if (Object.keys(this.props.eventIds).length === 0) {
      return null
    }
    return (
      <div style={styles.container}>
        <div style={styles.title}>Jobs Without A Specified Location</div>
        <div style={styles.rowContainer}>
          { this.renderCards() }
        </div>
      </div>
    )
  }
}

const styles = {
  container: {
    padding: 8,
    flexGrow: 1,
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: 104
  },
  rowContainer: {
    display: 'flex',
    flexDirection: 'row',
    overflowX: 'auto',
    overflowY: 'hidden',
    height: 88,
    width: 1280
  },
  title: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    marginTop: 4,
    marginLeft: 8,
    color: '#527da3',
    fontSize: 14
  }
}

export default connect(state => ({ instances: state.schedule.instances }))(BottomBar)



// WEBPACK FOOTER //
// ./src/schedule/map/BottomBar.js